<template>

    <div>
        <Loading/>
        <MenuInterno/>
        <span><strong> REGISTRO DE CONTAS </strong></span>

        <div v-if="listagem == 'listagem'" class="mt-5">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Cadastro de Conta</button>
            </div>
            <!-- <div style="height:700px;">
              <div id="gridbox" style="width:100%; height:100%; background-color:white;"></div>
            </div>
            <div class="my-3" style="margin-left: 800px;">
              <div id='recArea' class="bg-secondary text-center text-white mb-2"></div>
              <div id='recstate' class="text-center text-primary"></div>
            </div> -->
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th class="text-center">Unidade</th>
                    <th class="text-center">Contrato</th>
                    <th class="text-center">Mês Ref.</th>
                    <th class="text-center">Ano Ref.</th>
                    <th class="text-center">Fornecedor</th>
                    <th class="text-center">Data de Venc.</th>
                    <th class="text-center">Valor da Conta</th>
                    <th class="text-center">Ações</th>
                </tr>
                </thead>
            </table>
        </div>
        <div v-else-if="listagem == 'cadastro'">
            <CadastroContasCadastro/>
        </div>
        <div v-else-if="listagem == 'editar'">
            <CadastroContasEditar :id='id'/>
        </div>
    </div>

</template>

<script>
    import Loading from '@/components/Loading'
    import MenuInterno from '@/components/adm/MenuInterno'
    import CadastroContasCadastro from './CadastroContasCadastro.vue'
    import CadastroContasEditar from './CadastroContasEditar.vue'

    export default {
        name: 'CadastroContasListagem',
        components: {
            MenuInterno,
            Loading,
            CadastroContasCadastro,
            CadastroContasEditar
        },
        data() {
            return {
                listagem: 'listagem',
                paginaTop: '',
                id: ''
            }
        },

        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro'
                this.paginaTop = 'ADICIONAR CADASTRO CONTAS'
                $('#tabela').parents('div.dataTables_wrapper').first().hide();
            },
            viewEditar() {
                this.listagem = 'editar'
                this.paginaTop = 'EDITAR CADASTRO CONTAS'
            }
        },
        mounted: function () {
            let thiss = this;
            let swall = this.$swal;

            $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                     "sEmptyTable": "Nenhum dado encontrado",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                    "aoColumnDefs": [
                    { "bSortable": true, "aTargets": [ "_all" ] }
                    ]
                },
                "ajax": {
                    "url": axios.defaults.baseURL + "/api/contas-consumo/cadastro-contas",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        api.geraNovoTokenDatatable(jqXHR);
                    }
                },
                "columns": [
                    {"data": "ba03_id", visible: false},
                    {"data": "ba02_unidade"},
                    {"data": "ba04_numero"},
                    {"data": "ba03_mes_ref"},
                    {"data": "ba03_ano_ref"},
                    {"data": "fornecedor"},
                    {"data": "ba03_dt_vencimento"},
                    {"data": "ba03_valor_conta"},
                    {
                        targets: [8],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.ba03_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar';
                        thiss.paginaTop = 'EDITAR';
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    });

                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir a Conta selecionada?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    api.enviarRequisicao('delete', '/api/contas-consumo/cadastro-contas/' + thiss.id)
                                        .then(
                                            swall('Atenção', 'A Conta foi deletada com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        )
                                        .catch(error => {
                                            swall('Erro', 'A Conta está sendo usada', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });


            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // API.enviarRequisicao('get', '/api/conta-consumos/cadastro-contas/dhtmlx')
            //   .then(response => {
            //     this.dados = response.data;
            //     gridCadastroContas.parse(this.dados, "json");


            //     let paginaEditar = this;
            //     let uid = this;
            //     let paginaTopo = this;
            //     let swall = this.$swal;

            //     $('.editar').on('click', function(){
            //       var dados = $(this).data('id');
            //       uid.id = dados;
            //       paginaEditar.listagem = 'editar';
            //       paginaTopo.paginaTop = 'EDITAR';
            //     })

            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       uid.id = dados;

            //       swall({
            //         title: "Atenção?",
            //         text: "Deseja realmente excluir o cadastro de conta selecionado?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não cancelar!"
            //       })
            //       .then(
            //           function () {
            //             API.enviarRequisicao('delete', '/api/conta-consumos/cadastro-contas/'+uid.id)
            //             .then(
            //                swall('Parabéns', 'cadastro de conta deletado com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   })

            // gridCadastroContas = new dhtmlXGridObject("gridbox");
            // gridCadastroContas.setImagePath("libs/imgs/");
            // gridCadastroContas.setHeader("Código, Mes Ref., Ano Ref., Unidade, Tipo Conta, Fornecedor, Data de Venc., Consumo, Valor da Conta, Ações");
            // gridCadastroContas.setInitWidths("10,70,60,140,140,140,100,70,90,80*");
            // // gridCadastroContas.setSkin("modern");
            // gridCadastroContas.setColAlign("center,center,left,left,left,center,center,center");
            // gridCadastroContas.setColTypes("ro,ro,ro,ro,ro,ro,ro,ro,ro,ro");
            // gridCadastroContas.setColSorting("int,str,str,str,str,str,str,str,str");
            // gridCadastroContas.attachEvent("onRowCreated", function(id) {
            //     this.cells(id,9).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info' ></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //     return true;
            // });
            // gridCadastroContas.attachHeader("&nbsp;,#text_filter,#text_filter,#combo_filter,#combo_filter,#combo_filter,#text_filter,#text_filter,#text_filter,&nbsp;");
            // gridCadastroContas.setColumnHidden(0,true);
            // gridCadastroContas.init();
            // gridCadastroContas.enableSmartRendering(true,50);
        }
    }

</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>
